import React from 'react';

const CaseFinance = ({ invoices, payments }) => {
    const balance = invoices.reduce((s, i) => s + (Number(i.total_amount || 0)) - (Number(i.paid_amount || 0)), 0);

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                <h4 className="text-lg font-bold text-emerald-400 uppercase tracking-wider flex items-center gap-2">
                    💳 FINANCE
                </h4>
                <div className="font-mono text-sm">
                    <span className="text-gray-500 mr-2">BALANCE:</span>
                    <span className={`font-bold ${balance > 0 ? 'text-red-400' : 'text-green-400'}`}>
                        {balance.toLocaleString()}
                    </span>
                </div>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                    <h5 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-4 border-b border-gray-700 pb-2">Invoices</h5>
                    <ul className="space-y-3">
                        {invoices.map(inv => (
                            <li key={inv.id} className="p-3 bg-gray-700/30 rounded border border-gray-700 hover:bg-gray-700/50 transition-colors">
                                <div className="flex justify-between items-start mb-1">
                                    <div className="font-bold text-white font-mono text-sm">{inv.title || inv.number || inv.id}</div>
                                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold uppercase border ${inv.status === 'paid' ? 'bg-green-900/30 text-green-400 border-green-800' : 'bg-yellow-900/30 text-yellow-400 border-yellow-800'}`}>
                                        {inv.status || '-'}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center text-xs font-mono text-gray-400">
                                    <span>DUE: {inv.due_date || '-'}</span>
                                    <span className="text-white font-bold">{inv.total_amount || '-'}</span>
                                </div>
                            </li>
                        ))}
                        {invoices.length === 0 && <li className="text-center py-8 text-gray-500 font-mono uppercase">No invoices</li>}
                    </ul>
                </div>
                <div>
                    <h5 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-4 border-b border-gray-700 pb-2">Payments</h5>
                    <ul className="space-y-3">
                        {payments.map(p => (
                            <li key={p.id} className="p-3 bg-gray-700/30 rounded border border-gray-700 hover:bg-gray-700/50 transition-colors">
                                <div className="flex justify-between items-start mb-1">
                                    <div className="font-bold text-white font-mono text-sm">{p.method || 'Payment'}</div>
                                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold uppercase border bg-green-900/30 text-green-400 border-green-800">
                                        RECEIVED
                                    </span>
                                </div>
                                <div className="flex justify-between items-center text-xs font-mono text-gray-400">
                                    <span>ON: {p.paid_at || '-'}</span>
                                    <span className="text-white font-bold">{p.amount || '-'}</span>
                                </div>
                            </li>
                        ))}
                        {payments.length === 0 && <li className="text-center py-8 text-gray-500 font-mono uppercase">No payments</li>}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CaseFinance;
